import React from 'react';
import Card from '../../../Helper/CardWrapper/cardWrapper';
import Loader from '../../../Helper/loader/loader';
import Paper from '@material-ui/core/Paper';
import CloseIcon from '@material-ui/icons/Close';
import {Avatar, Table, TableCell, TableBody, TableRow} from '@material-ui/core';
import {withStyles} from '@material-ui/core/styles';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import IconButton from '@material-ui/core/IconButton';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import { updateVisitAction } from '../../../Actions/overviewActions';
import {getHereNow, getParticipants} from '../../../Actions/heatSpotAction';
import store from '../../../store';
import './heatSpot.css';
import moment from "moment";

const styles = {
    rows: {
        display: 'flex',
        justifyContent: 'center',
        margin: 10
    },
    row: {
        height: 0
    },
    imgAvatar: {
        margin: 10,
    },
    tableCellcss: {
        padding: 10,
        width: 100
    },
    avatar: {
        width: 45,
        height: 45,
        borderRadius:45/2,
    },
};

const headData = (props) => {
    return (
        <div className="headerMain">
            <div id="0"
                 className={Number(props.headerSelected) === 1 ? "participant-header" : "participant-header-selected"}
                 onClick={props.headerClicked}>
                { `Here Now ( ${props.totalHereNow ? (props.totalHereNow + 1) : 1} )`}
            </div>
            <div className="seperator"/>
            <div id="1"
                 className={Number(props.headerSelected) === 0 ? "participant-header" : "participant-header-selected"}
                 onClick={props.headerClicked}>
                { `Participants ( ${props.totalParticipants ? props.totalParticipants : 0} )`}
            </div>
        </div>
    )
};

const ParticipantsbodyData = (props) => {
    const classes = props;
    const participants = [];
    props.data.Participants && props.data.Participants.results.Participants.forEach((data, index) => {
        if (index % 4 === 0) {
            participants.push(<TableRow style={{height: 0}}/>);
        }
        participants.push(<TableCell className={classes.tableCellcss}>
            <div key={index} className="card">
                <div className="herenow-participants-user-img" key={index}>
                    {
                        data.ProfileImage
                            ?
                            <Avatar className={classes.imgAvatar} style={{height:'45px',width:'45px'}} src={data.ProfileImage} alt={'I'} />
                            :
                            <img
                                src={require(`./../../../images/Alphabets/${data.FirstName.match(/[a-z]/i)[0].toUpperCase()}.png`)}
                                height={45} width={45} alt="img"
                            />
                    }
                </div>
                <div key={index}><p className="card-header" title={data.FirstName}>{data.FirstName}</p>
                    <p className="card-body" title={`@${data.UserName}`}>{`@${data.UserName}`}</p></div>
            </div>
            <div className="participant-seperator" />
        </TableCell>);
    });
    return (
        <div className="body-main" onScroll={props.onParticipantScroll}>
            <div className={classes.rows}>
                <Table className="participants">
                    <TableBody className="participants-tbody">
                        {participants}
                    </TableBody>
                </Table>
            </div>
            {!props.data.Participants && <Loader />}
            {props.data.Participants && props.data.Participants.results.Participants.length < Number(props.data.Participants.results.TotalRecords) && <Loader />}
        </div>
    )
};

const HereNowbodyData = (props) => {
    const classes = props;
    const participants = [];

    {props.HereNow && props.HereNow.results && participants.push(<TableCell className={classes.tableCellcss}>

        <div className="card">
            <div className="avtar-img">
                {
                    props.user.ProfileImage ?
                        <Avatar className={classes.imgAvatar} style={{height:'45px',width:'45px'}} src={props.user.ProfileImage.substr(0,4) === 'http' ? props.user.ProfileImage :`https://d2gnb7jphto2jj.cloudfront.net/UploadImages/AppUserProfileImages/ProfileOriginalImage/${props.user.ProfileImage}`} alt={'I'} />
                        :
                        <Avatar className={classes.imgAvatar} style={{height:'45px',width:'45px'}} src={require(`./../../../images/Alphabets/${props.user.FirstName.match(/[a-z]/i)[0].toUpperCase()}.png`)} alt={'I'} />
                        // <img className={classes.avatar} src={require(`./../../../images/Alphabets/${props.user.FirstName.match(/[a-z]/i)[0].toUpperCase()}.png`)} alt="img" height={45} width={45} />
                }
            </div>
            <div><p className="card-header" title={props.user.FirstName}>{props.user.FirstName}</p>
                <p className="card-body" title={`@${props.user.UserName}`}>{`@${props.user.UserName}`}</p>
            </div>
        </div>
            <div className="participant-seperator" />
        </TableCell>);}
    props.HereNow && props.HereNow.results.CheckInUserDetail && props.HereNow.results.CheckInUserDetail.forEach((data, index) => {
        if ((index+1) % 3 === 0) {
            participants.push(<TableRow style={{height: 0}}/>);
        }
        participants.push(<TableCell key={index} className={classes.tableCellcss}>
            <div key={index} className="card">
                <div key={index} className="avtar-img">
                    {
                        data.ProfileImage
                            ?
                            <Avatar className={classes.imgAvatar} style={{height:'45px',width:'45px'}} src={data.ProfileImage.substr(0,4) === 'http' ? data.ProfileImage :`https://d2gnb7jphto2jj.cloudfront.net/UploadImages/AppUserProfileImages/ProfileOriginalImage/${data.ProfileImage}`} alt={'I'} />
                            :
                            <Avatar className={classes.imgAvatar} style={{height:'45px',width:'45px'}} src={require(`./../../../images/Alphabets/${data.FirstName.match(/[a-z]/i)[0].toUpperCase()}.png`)} alt={'I'} />
                            // <img className={classes.avatar} src={require(`./../../../images/Alphabets/${data.FirstName.match(/[a-z]/i)[0].toUpperCase()}.png`)} alt="img" height={45} width={45} />
                    }
                </div>
                <div>
                    <p className="card-header">{data.FirstName}</p>
                    <p className="card-body" title={`@${data.UserName}`}>{`@${data.UserName}`}</p>
                    <p className="card-body-sub">
                        <span>{moment.utc(data.checkInDate).local().format('MMM Do, YYYY')}</span>
                        {`  at  `}
                        <span>{moment.utc(data.checkInDate).local().format('hh:mm A')}</span>
                    </p>
                </div>
                <div className="messageIcon">
                    {/*<span className="participant-message-button-space"></span>*/}
                    {
                        data.lastMessageFromUserId > 0 && props.user.UserId === data.lastMessageFromUserId
                            ?
                            <IconButton onClick={() => props.showUserMessagesModal(data)}>
                                <img src={require('../../../images/mail_replied.png')} className="herenow-message-reply-button"/>
                            </IconButton>
                            :
                            <IconButton onClick={() => props.showUserMessagesModal(data)}>
                                <MailOutlineIcon className="participant-message-button" fontSize="large"/>
                            </IconButton>
                    }
                </div>
                <div>
                    <img src={require('../../../images/message_checkout.png')}
                         className="herenow-checkout-button"
                         onMouseUp={() => {
                             props.showCheckout(data)
                         }}
                    />
                </div>
                {data.unreadMessageCount > 0 && <span className="unread-badge">{data.unreadMessageCount}</span>}
                {props.showPopup ?
                    <Popup
                        text='Close Me'
                        closePopup={this.togglePopup}
                    />
                    : null
                }
            </div>
            <div className="participant-seperator" />
        </TableCell>);
    });

    return (
        <div className="body-main" onScroll={props.onHereNowScroll}>
            <div className={classes.rows}>
                <Table className="herenow">
                    <TableBody className="herenow-tbody">
                        {participants}
                    </TableBody>
                </Table>
            </div>
            {!props.HereNow && <Loader />}
            {props.HereNow && props.HereNow.results.CheckInUserDetail && props.HereNow.results.CheckInUserDetail.length < Number(props.HereNow && props.HereNow.results.TotalRecords) && <Loader />}
        </div>
    )
};

class Popup extends React.Component {
    render() {
        return (
            <div className='popup' onClick={this.props.closePopup}>
                <div className='popup_inner'>
                    <h1>{this.props.text}</h1>
                </div>
            </div>
        );
    }
}

class Participants extends React.Component {
    constructor() {
        super();
        this.state = {
            headerSelected: 0,
            ParticipantPageNumber:1,
            HereNowPageNumber:1,
            showPopup: false,
            participantsInfoMessageBubbleIsOpen: JSON.parse(store.getState().loginResponse.results.BusinessUser.IsFirstVisit)['Curbside Communication Here Now'] === 1
        };
    }

    onHereNowScroll = () => {
        let element = document.getElementsByClassName('body-main');
        if(element[0].clientHeight + element[0].scrollTop >= element[0].scrollHeight) {
            let HereNowData = {
                "Address": this.props.businessData.Address,
                "GooglePlaceId": this.props.businessData.PlaceID,
                "Latitude": this.props.businessData.Address_Lat,
                "Longitude": this.props.businessData.Address_Long,
                "PageNumber": this.state.HereNowPageNumber+1,
                "PageSize": 10,
                "PlaceName": this.props.businessData.BusinessName,
                "PlaceType": "point_of_interest,establishment",
                "UserId": this.props.user.UserId
            };
            this.props.getHereNow(HereNowData);
            this.setState({
                HereNowPageNumber:this.state.HereNowPageNumber + 1
            });
        }
    };

    onParticipantScroll = () => {
        if(this.props.data.Participants.results.Participants.length < this.props.data.Participants.results.TotalRecords) {
            let element = document.getElementsByClassName('body-main');
            if(element[0].clientHeight + element[0].scrollTop >= element[0].scrollHeight) {
                let participantsData = {
                    userId: this.props.user.UserId,
                    GooglePlaceId: this.props.businessData.PlaceID,
                    PageNumber:this.state.ParticipantPageNumber + 1,
                    PageSize:20
                };
                this.props.getParticipants(participantsData);
                this.setState({
                    ParticipantPageNumber:this.state.ParticipantPageNumber + 1
                });
            }
        }
    };

    componentDidMount() {
        let HereNowData = {
            "Address": this.props.businessData.Address,
            "GooglePlaceId": this.props.businessData.PlaceID,
            "Latitude": this.props.businessData.Address_Lat,
            "Longitude": this.props.businessData.Address_Long,
            "PageNumber": this.state.HereNowPageNumber,
            "PageSize": 20,
            "PlaceName": this.props.businessData.BusinessName,
            "PlaceType": "point_of_interest,establishment",
            "UserId": this.props.user.UserId
        };
        let participantsData = {
            userId: this.props.user.UserId,
            GooglePlaceId: this.props.businessData.PlaceID,
            PageNumber:this.state.ParticipantPageNumber,
            PageSize:20
        };
        this.props.getHereNow(HereNowData);
        this.interval = setInterval(() => {
            this.props.getHereNow(HereNowData);
            }, 5000
        );
        this.props.getParticipants(participantsData);
    }

    componentWillUnmount(){
        clearInterval(this.interval);
    }

    headerClicked = (e) => {
        this.setState({
            headerSelected: e.target.id
        });
    };

    togglePopup() {
        this.setState({
            showPopup: !this.state.showPopup
        });
    }

    closeParticipantsInfoMessage = () => {
        const placeId = store.getState().loginResponse.results.BusinessUser.PlaceID;
        let visit = JSON.parse(store.getState().loginResponse.results.BusinessUser.IsFirstVisit);
        visit['Curbside Communication Here Now'] = 0;
        this.props.updateVisitAction(placeId, JSON.stringify(visit));
        this.setState({
            participantsInfoMessageBubbleIsOpen: false
        });
    }

    participantsWrapperStyles = () => {
        return {
            margin: this.state.participantsInfoMessageBubbleIsOpen ? '-90px 0px 0px 0px' : '0px 0px 0px 0px'
        }
    }
    
    participantsInfoMessageBubbleStyles = () => {
        return {
            display: this.state.participantsInfoMessageBubbleIsOpen ? 'inline-block' : 'none',
            position: 'relative',
            backgroundColor: `rgb(42, 0, 74)`,
            color: '#f5f5f9',
            height: '100%',
            width: '475px',
            left: window.screen.width > 1300 ? '25%' : (window.screen.width > 960 ? '12%' : (window.screen.width > 870 ? '25%' :(window.screen.width > 750 ? '20%' : (window.screen.width > 650 ? '15%' : (window.screen.width > 550 ? '12%' : (window.screen.width > 500 ? '7%' : '0')))))),
            fontSize: '20px',
            zIndex: 1,
            padding: '8px 10px 13px 10px'
        }
    }

    render() {
        return (
            <React.Fragment>
                <div style={this.participantsWrapperStyles()}>
                    <div className="contactless-service-participants-message-wrapper">
                        <Paper style={this.participantsInfoMessageBubbleStyles()}>
                            <IconButton style={{color: 'white', float: 'right'}} onClick={this.closeParticipantsInfoMessage}>
                                <CloseIcon/>
                            </IconButton>
                            <span>{'See customers as they arrive and check-in to your business with the ability to send and receive messages in real-time!'}</span>
                            <div className="contactless-service-participants-message-bubble-triangle" />
                        </Paper>
                    </div>
                    <Card header={headData({
                        headerClicked: this.headerClicked,
                        headerSelected: this.state.headerSelected,
                        totalParticipants: this.props.data.Participants && this.props.data.Participants.results.TotalRecords,
                        totalHereNow: this.props.data.HereNow && this.props.data.HereNow.results.TotalRecords

                    })}
                        content={Number(this.state.headerSelected) === 1 ? ParticipantsbodyData({data:this.props.data,onParticipantScroll:this.onParticipantScroll}) : HereNowbodyData({
                              HereNow:this.props.data.HereNow,
                              user:this.props.user,
                              onHereNowScroll:this.onHereNowScroll,
                              userMessagesModalIsVisible: this.props.userMessagesModalIsOpen,
                              showUserMessagesModal: this.props.showUserMessagesModal,
                              showCheckout: this.props.showCheckout
                          })}
                          CardContentProps={{
                              style: {minHeight:this.props.toShow ? '28vh' : '32vh'}
                          }}
                          CardHeaderProps={{
                              style: {minHeight: '8vh'}
                          }}
                    />
                </div>
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        data: state.heatSpotReducer,
        user: state.loginResponse.results.AppUser,
        businessData: state.loginResponse.results.BusinessUser
    }
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        getParticipants,
        getHereNow,
        updateVisitAction
    }, dispatch);
};

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(Participants));
